module.exports = __webpack_public_path__ + "static/media/NTNUI-Redesign.51e9e7ed.jpg";